/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-01-11T13:51:01+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-02-03T14:16:52+02:00
 * @Copyright: Diversitude 2022
 */



export const state = {
    sops: null,
    notifications: null,
    sop_groups:null,
    sop_data: null,
    selected_sop_group: null,
    context_menu_id: null,
    is_loading_documents: false,
    sop_stats: null,
    workflows: [],
    assignable_sops: [],
    active_job_data: {}, 
}

export const mutations = {
    setNotifications(state, payload){//added
        state.notifications = payload;
    },
    setActiveJobData(state, payload) {//added
        state.active_job_data = payload;
    },
    setSops(state, payload){//added
        if(payload == null){
            return;
        }
        //payload.forEach( doc_group => {
            let found_index = state.sop_groups.findIndex( group => {
                return payload.id == group.id;
            })
            if(found_index != -1){
                state.sop_groups[found_index]['sops'] = payload.sop_types;
            }
    },

    setSelectedSopGroup(state, payload){ //added
        state.selected_sop_group = payload;
    },
    setSopGroups(state, payload){   //added
        state.sop_groups = payload;
    },
    clearStore(state, payload){
        state.sop_data = payload;
    },
    setSopData(state, payload){
        state.sop_data = payload;
    },
    setRightClickMenuID(state, payload){
        state.context_menu_id = payload;
    },
    resetStore(state, payload){
        state.sops = payload;
        state.notifications = payload;
        state.sop_groups = payload;
        state.sop_data = payload;
        state.selected_sop_group = payload;
        state.context_menu_id = payload;
    },
    

    // workflows
    setWorkflows(state, payload){
        state.workflows = payload;
    },
    setAssignableSops(state, payload){
        state.assignable_sops = payload;
    },
    clearSopDataForGroup(state){
        state.selected_sop_group = null;
        if(state.sop_groups != null){
            state.sop_groups.forEach( group => { group['sops'] = [] });
        }
    }
}

export const actions = {
    loadNotifications({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientadmin/notifications/')
            .then((response)=>{
                commit('setNotifications', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSopData({commit}, id){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/clientdocadmin/soptype/' + id)
            .then((response)=>{
                commit('setSopData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSops({commit}, id){
        return new Promise((resolve, reject)=>{
            commit('setSops', null);
            window.axios.get('api/clientdocadmin/sopgroup/' + id)
            .then((response)=>{
                commit('setSops', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSopGroups({commit}, reset = false){
        return new Promise((resolve, reject)=>{
            if(reset == true){
                commit('setSopGroups', null);
                resolve();
            }

            window.axios.get('api/clientdocadmin/sopgroups/')
            .then((response)=>{
                let data_object = response.data;
                let keys = Object.keys(data_object);
                let processed_data = [];
                keys.forEach( key => {
                    let item = data_object[key];
                    item['sops'] = [];
                    processed_data.push(item);
                })
                /*let processed_data = response.data.map( group => {
                    return {...group, sops:[]}
                })*/
                commit('setSopGroups', processed_data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    /*eslint-disable-next-line */
    saveSopType({commit}, params){//*  "id": -1, | "sop_group_id": 2, | "name": "Test Type", | "sop_code": "SOP-TYPE-002"
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/savesoptype', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    deleteSopType({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/deletesoptype', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    saveSopGroup({commit}, params){//* "id": -1 -- "parent_id": 0 -- "name": "Test Group"
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/savesopgroup', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    deleteSopGroup({commit}, params){//* 'id': 1
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/deletesopgroup', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    selectSopGroup({commit}, sop_group){
        return new Promise((resolve)=>{
            commit('setSelectedSopGroup', sop_group);
            resolve();
        });
    },
    clearSopStore({commit}){
        return new Promise((resolve) => {
            commit('clearStore', null);
            resolve();
        })
    },
    //eslint-disable-next-line
    approveSopRevision({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/approvesoprevision', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    previewSop({commit}, params){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/previewsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    getPreviewB64({commit}, revision_id){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.get('api/clientdocadmin/b64preview/' + revision_id)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    saveSopRevision({commit}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/saveclientsoprevision', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    uploadSignedSop({commit}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/uploadsignedsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //use to track active job actions from notification table 
    setActiveJobInfo({commit}, params) {
        return new Promise((resolve)=>{
            commit('setActiveJobData', params);
            resolve();
        });
    },
    //* id of the document item that was right clicked
    setContextMenuID({commit}, id){
        return new Promise((resolve)=>{
            commit('setRightClickMenuID', id);
            resolve();
        });
    },
    setSopFromMenu({commit}, sop){
        return new Promise((resolve)=>{
            commit('setSopData', sop);
            resolve();
        });
    },
    /*eslint-disable-next-line */
    setDocumentFlag({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientuser/saveactiontracking', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    distributeSOP({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/distributesop', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    approveSopDistribution({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/approvesopdist', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },


    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },//assignablesops
    loadAssignableSops({commit}, group_id = -1){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/clientdocadmin/assignablesops/${group_id}` )
            .then( (response) =>{
                commit('setAssignableSops', response.data)
                resolve(response);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    loadWorkflows({commit}, level_id = -1){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/clientdocadmin/sopassignment/${level_id}` )
            .then( (response) =>{
                commit('setWorkflows', response.data)
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    // eslint-disable-next-line
    assignSopToWorkflow({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/clientdocadmin/assignsop`, params )
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    // eslint-disable-next-line
    unassignSopToWorkflow({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/clientdocadmin/unassignsop`, params )
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    clearSopsFromGroup({commit}){
        commit('clearSopDataForGroup');
    },
    // eslint-disable-next-line
    deleteSopAttachment({}, params) {
        return new Promise((resolve, reject) => {
            window.axios.post(`api/clientdocadmin/deleteattachment`, params )
            .then( (response) =>{
                resolve(response);
            })
            .catch((error)=>{
                reject(error);
            })
        })
    }
}
